import { render } from "./dayCareClasses.vue?vue&type=template&id=0ec64b74&scoped=true&ts=true"
import script from "./dayCareClasses.vue?vue&type=script&lang=ts"
export * from "./dayCareClasses.vue?vue&type=script&lang=ts"

import "./dayCareClasses.vue?vue&type=style&index=0&id=0ec64b74&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec64b74"]])

export default __exports__